import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { IMonitorsGroupedByTags } from '../models/interfaces/monitors-grouped-by-tags.interface';
import { PdfPlaylistViewModel } from '../models/pdf-playlist.view-model';

@Injectable({
  providedIn: 'root'
})
export class PdfSelectionService {

  private selectedMonitorTags: IMonitorsGroupedByTags[] = [];

  public allMonitorsGroupedByTags: BehaviorSubject<IMonitorsGroupedByTags[]> =
    new BehaviorSubject<IMonitorsGroupedByTags[]>([]);
  public selectedmonitorsChanged: BehaviorSubject<IMonitorsGroupedByTags[]> =
    new BehaviorSubject<IMonitorsGroupedByTags[]>([]);

  public pdfDragActivationSubject: BehaviorSubject<boolean> = new BehaviorSubject(null);
  public pdfItemlistDragSubject: BehaviorSubject<PdfPlaylistViewModel> = new BehaviorSubject<PdfPlaylistViewModel>(null);

  public selectMonitorTag(monitorTagGrouped: IMonitorsGroupedByTags): void {
    if (this.selectedMonitorTags && !_.some(this.selectedMonitorTags, ((monTag: IMonitorsGroupedByTags) =>
      monTag.MonitorTagViewModel.Id === monitorTagGrouped.MonitorTagViewModel.Id))) {
      this.selectedMonitorTags.push(monitorTagGrouped);
      this.selectedmonitorsChanged.next(this.selectedMonitorTags);
    }
  }

  public unselectMonitorTag(monitorTagGrouped: IMonitorsGroupedByTags): void {
    _.remove(this.selectedMonitorTags, (monTag: IMonitorsGroupedByTags) =>
      monTag.MonitorTagViewModel.Id === monitorTagGrouped.MonitorTagViewModel.Id);
    this.selectedmonitorsChanged.next(this.selectedMonitorTags);
  }

  public unselectAll(): void {
    this.allMonitorsGroupedByTags.value.forEach((monTag: IMonitorsGroupedByTags) => {
      this.unselectMonitorTag(monTag);
    });
  }

  public selectAll(): void {
    this.allMonitorsGroupedByTags.value.forEach((monTag: IMonitorsGroupedByTags) => {
      this.selectMonitorTag(monTag);
    });
  }

  public selectByIds(monitorTagIdsToSelect: number[]): void {

    const selectedScreens: IMonitorsGroupedByTags[] = _.filter(this.allMonitorsGroupedByTags.value,
      (monTag: IMonitorsGroupedByTags) => _.some(monitorTagIdsToSelect, (monTagId: number) =>
        monTagId === monTag.MonitorTagViewModel.Id)
    );

    this.selectedMonitorTags = selectedScreens;
    this.selectedmonitorsChanged.next(selectedScreens);
  }

  public handlePDFItemlistDrag(dragData: PdfPlaylistViewModel): void {
    this.pdfItemlistDragSubject.next(dragData);
  }

  public handlePDFIDragActivation(isActive: boolean): void {
    this.pdfDragActivationSubject.next(isActive);
  }
}
